import { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../lib/firebase";
import styles from "./Contact.module.css";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", body: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [errorMsg, setErrorMsg] = useState("");

  function update(field) {
    return (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (!form.email || !form.body) return;
    setStatus("sending");
    try {
      await addDoc(collection(db, "contactMessages"), {
        ...form,
        createdAt: serverTimestamp(),
      });
      setStatus("sent");
      setForm({ name: "", email: "", subject: "", body: "" });
    } catch (err) {
      setErrorMsg(err.message);
      setStatus("error");
    }
  }

  return (
    <section id="contacto" className={styles.wrap}>
      <header className={styles.head}>
        <span className="mono-tag">// 05 — Contacto</span>

        <h2 className={styles.h2}>
          ¿Tienes un equipo<br />
          <span className={styles.alt}>que aún no existe?</span>
        </h2>
        <p className={styles.lead}>
          Cuéntanos el requerimiento técnico de tu laboratorio o planta y te
          responderemos con una propuesta de ingeniería.
        </p>
      </header>

      <div className={styles.grid}>
        <form className={styles.form} onSubmit={onSubmit}>
          <label className={styles.field}>
            <span>Nombre o empresa</span>
            <input
              value={form.name}
              onChange={update("name")}
              type="text"
              placeholder="Ej. Juan Pérez · Universidad / Empresa"
              required
            />
          </label>
          <label className={styles.field}>
            <span>Correo de contacto</span>
            <input
              value={form.email}
              onChange={update("email")}
              type="email"
              placeholder="nombre@empresa.com"
              required
            />
          </label>
          <label className={styles.field} data-span="full">
            <span>Asunto / Tipo de proyecto</span>
            <input
              value={form.subject}
              onChange={update("subject")}
              type="text"
              placeholder="Ej. Diseño de equipo de laboratorio / Automatización / Retrofit"
            />
          </label>
          <label className={styles.field} data-span="full">
            <span>Cuéntanos qué necesitas</span>
            <textarea
              value={form.body}
              onChange={update("body")}
              rows={5}
              placeholder="Describe brevemente el proceso, capacidades requeridas o el equipo que buscas desarrollar o modernizar…"
              required
            />
          </label>

          <button
            type="submit"
            className={styles.submit}
            disabled={status === "sending"}
          >
            {status === "sending" ? "Enviando…" : "Enviar mensaje"}
            <svg viewBox="0 0 24 12" width="22" height="11" aria-hidden="true">
              <path d="M0 6 H22 M16 1 L22 6 L16 11" fill="none" stroke="currentColor" strokeWidth="1.4" />
            </svg>
          </button>

          {status === "sent" && (
            <p className={styles.ok}>↳ Recibido. Nuestro equipo te responderá pronto.</p>
          )}
          {status === "error" && (
            <p className={styles.err}>// error: {errorMsg}</p>
          )}
        </form>

        <aside className={styles.side}>
          <div className={styles.infoCard}>
            <span className="mono-tag">// canales directos</span>
            <div className={styles.infoBlock}>
              <span className={styles.infoLabel}>Correo comercial y técnico</span>
              <a href="mailto:ventas@ayatech.com.pe">ventas@ayatech.com.pe</a>
              <a href="mailto:ken.qm@ayatech.com.pe">ken.qm@ayatech.com.pe</a>
            </div>
            <div className={styles.infoBlock}>
              <span className={styles.infoLabel}>Ubicación</span>
              <p>Arequipa, Perú · Atención a nivel nacional</p>
            </div>
            <div className={styles.infoBlock}>
              <span className={styles.infoLabel}>Horario de atención</span>
              <p>Lunes a viernes · 09:00 – 18:00 (GMT-5)</p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}
